import React from 'react'

function GroupReportLayer() {
  return (
    <div>

    </div>
  )
}

export default GroupReportLayer
